import { useAppSelector } from 'app/state'
import { isAutosavingEnabledSelector } from 'features/builder/state/builderSlice'
import { RequestStatus } from 'features/common'

function useMapSavingState() {
  const currentMap = useAppSelector((state) => state.maps.currentMap)
  const isLoading = useAppSelector((state) => state.maps.mapEditStatus === RequestStatus.Pending)
  const isAutosavingEnabled = useAppSelector(isAutosavingEnabledSelector)
  const saveNeeded = useAppSelector((state) => state.builder.saveNeeded)

  return { currentMap, isLoading, isAutosavingEnabled, saveNeeded }
}

export default useMapSavingState
